/**
 * Created by Administrador on 10/24/2016.
 */
(function(){
    'use strict';

    var wizard = {
        transclude: true,
        templateUrl: 'app/components/wizard/wizard.html',
        controller: wizardController,
        controllerAs: 'vm',
        bindings:{
            wizardStyle: '@',
            position: '@',
            isControls: '='
        }
    };

    angular
        .module('completeAir')
        .component('wizard', wizard);

    function wizardController(){
        var vm = this;
        vm.wizardStepLi = 0;

        vm.$onInit = function(){
            vm.wizards = [];
            vm.wizardStep = vm.firstWizard();
            vm.wizardStepSize = 0;

            if(vm.position == undefined || vm.position == ""){
                vm.position = "horizontal";
            }
        }

        vm.addWizard = function(wizard){
            var there = vm.wizardThere(wizard);

            if(!there){
                vm.wizards.push(wizard);
            }

            vm.wizardStepSize = vm.wizards.length;
            vm.wizardStepLi = 100 / vm.wizards.length;

            if (vm.wizards.length > 0) {
                vm.wizards[0].selected = true;
            }
        }

        vm.selectWizard = function(index){
            for (var i = 0; i < vm.wizards.length; i++) {
                vm.wizards[i].selected = false;
            }
            vm.wizards[index].selected = true;
            vm.wizardStep = index + 1;
        }

        vm.previousWizard = function(indexPrevious){
            vm.selectWizard(indexPrevious-1);
        }


        vm.nextWizard = function(indexNext){
            vm.selectWizard(indexNext-1);
        }

        vm.firstWizard = function(){
            return 1;
        }

        vm.lastWizard = function(){
            return vm.wizards.length;
        }

        vm.disabledPrevious = function(){
            return vm.wizardStep == vm.firstWizard();
        }

        vm.disabledNext = function(){
            return vm.wizardStep == vm.lastWizard();
        }

        vm.wizardThere = function(wizard){
            var res = false;
            for(var i = 0; i < vm.wizards.length; i++){
                if(vm.wizards[i].key == wizard.key){
                    res = true;
                }
            }
            return res;
        }

        vm.getStyleWizard = function(){
            var style = "";

            switch(vm.position){
                case 'horizontal':
                    style = "nav-wizard-tabs"
                    break;
                case 'vertical':
                    style = "nav-wizard-tabs vertical"
                    break;
            }
            return style;
        }
    }
})();
